import { render } from "./notice-center-wrapper.vue?vue&type=template&id=63877ed0&scoped=true"
import script from "./notice-center-wrapper.vue?vue&type=script&lang=js"
export * from "./notice-center-wrapper.vue?vue&type=script&lang=js"

import "./notice-center-wrapper.vue?vue&type=style&index=0&id=63877ed0&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63877ed0"],['__file',"src/components/notice-center-wrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63877ed0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63877ed0', __exports__)) {
    api.reload('63877ed0', __exports__)
  }
  
  module.hot.accept("./notice-center-wrapper.vue?vue&type=template&id=63877ed0&scoped=true", () => {
    api.rerender('63877ed0', render)
  })

}


export default __exports__